import type { ReplaceAllMapObj } from "./replaceAll.d";

const replaceAll = <Type>(content: Type, mapObj: ReplaceAllMapObj): Type => {
  const strJSON = JSON.stringify(content);

  const re = new RegExp(Object.keys(mapObj).join("|"), "gi");

  const output = strJSON.replace(re, (matched) => mapObj[matched.toLowerCase()]);

  return JSON.parse(output);
};

export default replaceAll;
